var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.292,
    height: 22.601,
    viewBox: "0 0 16.292 22.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-line",
    transform: "translate(-7 -4.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5544",
    "data-name": "Pfad 5544",
    d: "M17.333,20.59a1.651,1.651,0,0,0-1.589,1.277,1.671,1.671,0,0,0,.844,1.866v1.976h1.367V23.8a1.669,1.669,0,0,0,.992-1.861A1.652,1.652,0,0,0,17.333,20.59Z",
    transform: "translate(-2.191 -2.956)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5545",
    "data-name": "Pfad 5545",
    d: "M21.071,11.389V8.332a5.925,5.925,0,1,0-11.849,0v3.057H7V23.532a1.456,1.456,0,0,0,1.481,1.429h13.33a1.456,1.456,0,0,0,1.481-1.429V11.389ZM10.7,8.332a4.444,4.444,0,1,1,8.887,0v3.057H10.7Zm-2.222,15.2V12.817h13.33V23.532Z",
    transform: "translate(0 2.066)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.7f547f20238e065b92254cd0c8796b83.svg";
export { ForwardRef as ReactComponent };